import { Injectable, OnDestroy } from '@angular/core';
import { AbstractCRUDService } from '@campaign-portal/components-library';
import { EntityField, InputComplexType, InputType } from '@campaign-portal/namespace/common/entityField';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class SystemCodesFieldsService implements AbstractCRUDService, OnDestroy {
	readonly id: EntityField = {
		id: 0,
		name: 'system_codes.id',
		variable: 'id',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly codeValue: EntityField = {
		id: 1,
		name: 'system_codes.code_value',
		variable: 'value',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly type: EntityField = {
		id: 2,
		name: 'system_codes.type',
		variable: 'type',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.SELECT,
		data: ['Any', 'Default', 'User']
	};
	readonly codeDescription: EntityField = {
		id: 3,
		name: 'system_codes.code_description',
		variable: 'description',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly lastUpdated: EntityField = {
		id: 4,
		name: 'system_codes.last_updated',
		variable: 'lastUpdated',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	
	readonly entity = '';
	readonly title = '';
	readonly loading$ = new BehaviorSubject<boolean>(false);
	readonly headers: EntityField[] = [
		this.id,
		this.codeValue,
		this.type,
		this.codeDescription,
		this.lastUpdated,
	];
	
	constructor() {
	}
	
	ngOnDestroy(): void {
		this.loading$.complete();
	}
	
	read(): Observable<ReadResponse<EntityField[]>> {
		return of({
			Success: true,
			Total: this.headers.length,
			Data: this.headers
		});
	
	}
	
	create(): Observable<void> {
		return of();
	}
	
	update(): Observable<void> {
		return of();
	}
	
	delete(): Observable<void> {
		return of();
	}
}
